module.exports = __webpack_public_path__ + "img/list_icon.50445ee6.svg";